import React from 'react'
import classNames from 'classnames'

function FactBox({content, modifierContainerClasses = []}) {

  const containerClasses = classNames(
    'fact-box',
    modifierContainerClasses,
  )
  
  /** Filter out preamble tag */
  const filteredContent = content => content.replace('<div class="formatted-content preamble preamble--large u-mb-200">', '').replace('</div>', '')

  return (
    <div className={containerClasses}>
      <div className="formatted-content">
        <div dangerouslySetInnerHTML={{__html: filteredContent(content)}} />
      </div>
    </div>
  )
}

export default FactBox
